/**
 * Display form of a permit's `issued_date` at its `issued_date_precision`
 * (molluskio#5313). Some publishers only give a month or a year. Their dates
 * are stored as `YYYY-MM-01` / `YYYY-01-01` and must not read as exact days:
 *
 * - `'month'` → `May 2026`
 * - `'year'`  → `2026`
 * - `'day'`, NULL, missing, or any unknown value → the ISO date unchanged
 *
 * A malformed date is returned unchanged rather than guessed at.
 */
const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
const ISO_DATE = /^(\d{4})-(\d{2})-\d{2}$/;
export function formatIssuedDate(date, precision) {
    if (date === null || date === undefined)
        return null;
    const m = ISO_DATE.exec(date);
    if (!m)
        return date;
    const [, year, month] = m;
    if (precision === 'year')
        return year ?? date;
    if (precision === 'month') {
        const name = MONTHS[Number(month) - 1];
        return name ? `${name} ${year}` : date;
    }
    return date;
}
//# sourceMappingURL=formatIssuedDate.js.map